import { createAsyncThunk } from '@reduxjs/toolkit';
import api from '../../utils/api';

export const CREATE_COMPLAINT_ENDPOINT = '/api/v1/complaints';
export const COMPLAINT_TYPE_ENDPOINT = '/api/v1/complaint-types';

const rejectRequest = (error, thunkApi) => {
  const data = error?.response?.data;
  const details = Array.isArray(data?.errors)
    ? data.errors.map((item) => item?.message).filter(Boolean)
    : [];

  return thunkApi.rejectWithValue({
    status: error?.response?.status ?? error?.status,
    message:
      (details.length ? details.join(' ') : null) ??
      data?.message ??
      data?.error ??
      error?.message ??
      'Something went wrong',
  });
};

export const createComplaint = createAsyncThunk(
  'createComplaint/create',
  async (payload, thunkApi) => {
    try {
      const response = await api.post(CREATE_COMPLAINT_ENDPOINT, payload, {
        signal: thunkApi.signal,
      });
      return response.data;
    } catch (error) {
      return rejectRequest(error, thunkApi);
    }
  },
);

export const updateComplaintTypeActive = createAsyncThunk(
  'createComplaint/updateActive',
  async ({ id, isActive, onSuccess, onFail }, thunkApi) => {
    try {
      const response = await api.patch(
        `${COMPLAINT_TYPE_ENDPOINT}/${id}`,
        { isActive },
        { signal: thunkApi.signal },
      );
      if (onSuccess && typeof onSuccess === 'function') {
        onSuccess(response.data);
      }
      return response.data;
    } catch (error) {
      // console.log('updateComplaintTypeActive error:', error);
      if (onFail && typeof onFail === 'function') {
        onFail(error);
      }
      return rejectRequest(error, thunkApi);
    }
  },
);
